import React from "react";
import styles from "./tile.module.css";

export default function Tile(props) {
  return (
    <div
      className={
        props.type === "round" ? styles.tileContainer : styles.flatTile
      }
      style={props.style}
      onClick={props.onclick}
    >
      {props.icon && <i className={`fas fa-${props.icon}`}></i>}
      <p> {props.name}</p>
    </div>
  );
}
